import { render, staticRenderFns } from "./AddCourseMoreInfo.vue?vue&type=template&id=e49847de&"
import script from "./AddCourseMoreInfo.vue?vue&type=script&lang=ts&"
export * from "./AddCourseMoreInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports